<template>
    <div>
      <vue-echarts
        class="echart-container"
        autoresize
        :option="gaugeOption"
      />
    </div>
  </template>
  
  <script>
  // Import ECharts modules manually to reduce bundle size
  import * as echarts from 'echarts/core';
  import { GaugeChart } from 'echarts/charts';
  import {
    TitleComponent,
    TooltipComponent
  } from 'echarts/components';
  import { CanvasRenderer } from 'echarts/renderers';
  import ECharts from 'vue-echarts';
  
  // Register the required components
  echarts.use([
    TitleComponent,
    TooltipComponent,
    GaugeChart,
    CanvasRenderer
  ]);
  
  export default {
    components: {
      'vue-echarts': ECharts
    },
    data() {
      return {
        gaugeOption: {
          tooltip: {
            formatter: '{a} <br/>{b} : {c}%'
          },
          series: [
            {
              name: 'Pressure',
              type: 'gauge',
              detail: { formatter: '{value}%' },
              data: [{ value: 50, name: 'SCORE' }]
            }
          ]
        }
      };
    }
  };
  </script>
  
  <style>
  .echart-container {
    height: 400px;
    width: 100%;
  }
  </style>
  